export const DISALLOW_SMS = [
    'tms',
    'php-iop',
];
